export default {
	uploadNewImage: '新しい画像をアップロード',
	download: 'ダウンロード',
	background: {
		title: '背景',
		panel: {
			colour: '色',
			image: '画像',
			confirm: '確認',
			upload: 'アップロード',
		},
	},
	uploadTip: '画像をアップロードしてください',
};
